import { useContext, useEffect, useMemo, useState } from 'react'
import DataGrid from 'react-data-grid'
import type { 
  FormatterProps,
} from 'react-data-grid'
import { PicklistItemRecordTotalColumn } from '../../../constants/Column'
import { DgtPdOrderPicklistMovement } from '../../../models'
import Modal from '../../../components/Modal'
import { groupBy as rowGrouper } from 'lodash';
import { 
  OrderPicklistMovement 
} from '../../../components/types'
import MovementContext from '../../../contexts/MovementContext'

type RecordPicklistDialogConfProps = {
  orderId: string,
  show: boolean,
  onHide: () => void,
  onCompleted: (wasteMvs: DgtPdOrderPicklistMovement[]) => void
}

const RecordPicklistDialogConf = ({ orderId, show, onHide, onCompleted } : RecordPicklistDialogConfProps) => {

  const [ expandedGroupIds, setExpandedGroupIds ] = useState<ReadonlySet<unknown>>(
    () => new Set<unknown>([''])
  );

  const movementContext = useContext(MovementContext)

  useEffect(() => {
    const totalMovements = movementContext?.movements || []
    if (totalMovements.length > 0) {
      setExpandedGroupIds(new Set(totalMovements
        .filter(mv => totalMovements.filter(mv1 => mv1.materialCode === mv.materialCode).length > 1)
        .map(itm => itm.materialCode)
        ))
    }
  }, [ movementContext?.movements ])

  const wasteMovements = useMemo(() => 
    movementContext?.movements.filter(mv => mv.returnWasteQty! > 0)
  , [ movementContext?.movements ])

  const isDisableSubmit = useMemo(() => (movementContext?.movements || [])
    .filter(mv => mv.materialType === 'PKG' || mv.materialType === 'RAW')
    .filter(mv => mv.returnGoodQty! >= 0.001 || mv.returnGoodShrinkQty! >= 0.001) // note : prevent float number issue (0.0000000000821...) and remove waste return case
    .filter(mv => !mv.returnReasonCode)
    .length > 0
  , [ movementContext?.movements ])
  // note - comment for allow submit for investigate issue

  let columns = Array.from(PicklistItemRecordTotalColumn)
  columns.splice(PicklistItemRecordTotalColumn.length - 1, 0, 
    { key: 'returnReasonCode', name: 'เหตุผลคืน', width: 100,
      formatter: ({ row }: FormatterProps<OrderPicklistMovement>) => {
        return <>{row.returnReasonDescription}</>
      },
      groupFormatter({ childRows }) {
        return <div className='font-bold'>{childRows.length === 1 ? childRows[0].returnReasonDescription : '' }</div>
      }
    }
  )
  return <Modal show={show}
    onHide={onHide}
    title='สรุปยอดใช้/คืนรายการทั้งหมด ดังนี้'
    cancelText='ปิด'
    okText='ยืนยัน'
    okTheme='success'
    okAction={() => onCompleted(wasteMovements || [])}
    fullWidth={true}
    okDisable={isDisableSubmit}
  >
    <>
      <h5 className="mb-2 ">ORDER# {orderId}</h5>
      <DataGrid
        style={{ height: 'fit-content' }}
        columns={columns}
        rows={movementContext?.movements || []}
        rowKeyGetter={(row) => row.id}
        groupBy={['materialCode']}
        rowGrouper={rowGrouper}
        expandedGroupIds={expandedGroupIds}
        onExpandedGroupIdsChange={setExpandedGroupIds}
        defaultColumnOptions={{ resizable: true }}
      />
      {isDisableSubmit ? <p className='italic text-right text-red-500 '>กรุณาเลือกเหตุผลคืน</p> : null}
      <p className="w-full py-2 italic text-right">หมายเหตุ : รายการที่มียอดคืนดี กรุณาเขียนใบคืนตาม process ปกติ</p>
    </>
  </Modal>
}

export default RecordPicklistDialogConf